// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a81c3449","513":"61f6614f","703":"125a2840"}[chunkId] + ".chunk.js";
};